module.exports = __webpack_public_path__ + "static/img/son8.1af519a8.jpg";